import {toNumber} from "lodash";

export default {
    updateLocationSelected(value) {
        this.locationSelected = toNumber(value)
    }
}
